<template>
    <section class="feature_product_area section_gap_bottom_custom">
    <div class="container">
      <div class="row">
           <Product v-for="item in list.slice(0, 3)" :key="item.id" :product="item"/>
      </div>
      <HowToUseText/>
    </div>

  </section>
</template>
<script>
import HowToUseText from '@/components/HowToUseText'
import Product from '@/components/Product'
import list from '../config/products.json'

export default {
  data () {
    return {
      list
    }
  },
  components: {
    HowToUseText,
    Product
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ProductList.vue